
  import { Vue, Prop, Component, Watch } from "vue-property-decorator";

  import RadioButtonGroup from "@/components/common/RadioButtonGroup.vue";
  import FiltersContainer from "@/components/filters/filters-containerNew.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import FormGroup from "@/components/form/FormGroupNew.vue";
  import SkillsMultiselect from "@/components/autocompleteMultiselects/SkillsMultiselectNew.vue";
  import CustomRequestStatusMultiselect from "@/components/autocompleteMultiselects/CustomRequestStatusMultiselectNew.vue";
  import ManagersMultiselect from "@/components/autocompleteMultiselects/ManagersMultiselectNew.vue";
  import inputFilterDebounceTime from "@/data/inputFilterDebounceTime";
  import UiButtonMessage from "@/components/button/ui-button-message.vue";

  @Component({
    components: {
      RadioButtonGroup,
      UiButtonMessage,
      UiButton,
      FiltersContainer,
      FormGroup,
      SkillsMultiselect,
      CustomRequestStatusMultiselect,
      ManagersMultiselect,
    },
  })
  export default class CustomRequestFilters extends Vue {
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: Boolean, default: false }) readonly isAdmin!: boolean;

    jobTitle  = "";
    skillsIds: number[] = [];
    managerIds: string[] = [];
    statusIds: string[] = [];
    inputDebounceTime = inputFilterDebounceTime;

    get showManagerFilter(): boolean {
      return this.isAdmin;
    }

    get trimmedJobTitle(): string {
      return this.jobTitle.trim();
    }

    get propToWatch(): string {
      return JSON.stringify([
        this.trimmedJobTitle,
        this.skillsIds,
        this.managerIds,
        this.statusIds,
      ]);
    }

    @Watch("propToWatch")
    handlePropToWatchChange(): void {
      this.$emit("filtersChanged", {
        skillsIds: this.skillsIds,
        jobTitle: this.trimmedJobTitle,
        statusIds: this.statusIds,
        managersIds: this.managerIds,
      });
    }

    handleReset(): void {
      this.$emit("resetFilters");
      this.jobTitle = "";
      this.managerIds = [];
      this.skillsIds = [];
      this.managerIds = [];
      this.statusIds = [];
    }
  }
